import type { DeliveryFormat } from "@/types";

/** Formats de livraison proposés dans le brief (choix multiple, optionnel). */
export const DELIVERY_FORMATS: DeliveryFormat[] = [
    { id: "STEP", label: "STEP", hint: "Modèle 3D neutre" },
    { id: "PDF", label: "PDF", hint: "Plan imprimable" },
    { id: "DXF", label: "DXF", hint: "Découpe / 2D" },
    { id: "DWG", label: "DWG", hint: "2D natif" },
    { id: "AUTRE", label: "Autre", hint: "À préciser" },
];

/** Fichiers acceptés dans l'uploader. */
export const UPLOAD_ACCEPT = [".pdf", ".step", ".stp", ".dxf", ".dwg", ".zip", ".jpg", ".jpeg", ".png"];
export const UPLOAD_MAX_MB = 20;
export const UPLOAD_MAX_FILES = 8;
export const UPLOAD_LABEL = "PDF · STEP · STP · DXF · DWG · ZIP · JPG · PNG";
